import { render, staticRenderFns } from "./indexFooter.vue?vue&type=template&id=1a866b2e&scoped=true&"
import script from "./indexFooter.vue?vue&type=script&lang=js&"
export * from "./indexFooter.vue?vue&type=script&lang=js&"
import style0 from "./indexFooter.vue?vue&type=style&index=0&id=1a866b2e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a866b2e",
  null
  
)

export default component.exports